export const CheckoutRoute = "/checkout";
export const CheckoutEntryRoute = `${CheckoutRoute}/entry/:entryId`;
export const CheckoutPlanRoute = `${CheckoutRoute}/plan/:planId`;
export const CheckoutCartRoute = `${CheckoutRoute}/cart`;

export const buildCheckoutEntryUrl = (entryId: number) =>
	`${CheckoutRoute}/entry/${entryId}`;

export const buildCheckoutPlanUrl = (planId: number) =>
	`${CheckoutRoute}/plan/${planId}`;

export const buildCheckoutCartUrl = () => CheckoutCartRoute;
